module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('ul', {
    staticClass: "nav navbar-nav navbar-left",
    attrs: {
      "slot": "toolbar_buttons"
    },
    slot: "toolbar_buttons"
  }, [_c('li', [_c('date-range-picker', {
    attrs: {
      "datesRange": _vm.datesRange
    },
    on: {
      "dates-range-updated": _vm.updatedDates
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 main with-leads-table with-leads-table-active",
    attrs: {
      "slot": "main",
      "id": "dashboard-canvas"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "row ls-charts"
  }, [_c('h1', [_vm._v("Requests "), (_vm.stats.customer) ? _c('span', [_vm._v("- " + _vm._s(_vm.stats.customer))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Total")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "metrics-banner-text text-center"
  }, [_vm._v(_vm._s(_vm.stats.total))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("OK")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "metrics-banner-text text-center"
  }, [_vm._v(_vm._s(_vm.stats.ok))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Errors")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "metrics-banner-text text-center"
  }, [_vm._v(_vm._s(_vm.stats.error))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Tests")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "metrics-banner-text text-center"
  }, [_vm._v(_vm._s(_vm.stats.test))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("% Error")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "metrics-banner-text text-center"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.errorRate)))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Requests by Day")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "target-id": 'requests_flow',
      "bc-data": _vm.stats.requests_flow.series,
      "bc-layout": _vm.stats.requests_flow.layout
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Stats by Campaign")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ls-stats-table', {
    attrs: {
      "table-data": _vm.stats.stats_by_campaign,
      "table-layout": _vm.by_campaign_layout
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Distribution by Campaign")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "target-id": 'counts_by_campaign',
      "bc-data": _vm.stats.counts_by_campaign.series,
      "bc-layout": _vm.stats.counts_by_campaign.layout
    }
  })], 1)])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8adf2fdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/VendorsHome.vue
// module id = 668
// module chunks = 0